'use client';

import { useState, useEffect } from 'react';
import { IoFlagOutline } from 'react-icons/io5';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function FlagButton() {
  const [isOpen, setIsOpen] = useState(false);

  // Fermeture par ESC
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen]);

  // Empêcher scroll du body quand modale ouverte
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Bouton drapeau */}
      <Button
        variant="secondary"
        size="icon"
        aria-label="Signaler un problème"
        className="rounded-full bg-white text-primary shadow-lg hover:bg-primary hover:text-white"
        onClick={() => setIsOpen(true)}
      >
        <IoFlagOutline className="w-8 h-8" />
      </Button>

      {/* Modale */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            onClick={() => setIsOpen(false)}
            aria-hidden="true"
          />

          {/* Contenu modale */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
              className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 animate-in fade-in-0 zoom-in-95 duration-200"
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="flag-modal-title"
            >
              {/* Bouton fermer */}
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors"
                aria-label="Fermer"
              >
                <X className="w-5 h-5" />
              </button>

              {/* Titre */}
              <h2
                id="flag-modal-title"
                className="text-lg font-semibold text-gray-900 mb-4 pr-8"
              >
                Signaler un problème
              </h2>

              {/* Texte principal */}
              <p className="text-base text-gray-700 leading-relaxed">
                Si vous rencontrez un dysfonctionnement technique ou si vous
                trouvez un contenu inapproprié ou erroné, merci de nous écrire
                par mail à{' '}
                <a
                  href="mailto:victoria-assistance@veolia.com"
                  className="text-primary underline hover:text-primary/80 transition-colors"
                >
                  victoria-assistance@veolia.com
                </a>
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
}
